import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function ParkingIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_18673_3427)">
          <path
            d="M8.125 11.25H10.625C11.2052 11.25 11.7616 11.0195 12.1718 10.6093C12.582 10.1991 12.8125 9.64266 12.8125 9.0625C12.8125 8.48234 12.582 7.92594 12.1718 7.5157C11.7616 7.10547 11.2052 6.875 10.625 6.875H8.125V13.125M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_18673_3427">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  )
}
